import React, { useEffect } from 'react'
import {
  Container,
  Button,
  TextBody,
  TextCaption,
  TextTitle,
  ListContainer
} from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'
import { CartCheckoutGuestActions } from '@zyn-common/components'

const CartSummary = ({
  subtotal,
  total,
  delivery,
  deliveryFlat,
  isCheckoutDisabled,
  familyNotice,
  translations,
  isAuthenticated,
  handleCartValidation,
  handleSummaryLayoutUpdate,
  compact,
  goToCheckoutCTALoading
}) => {
  const handleSummaryLayoutUpdateHandler = () => {
    if (handleSummaryLayoutUpdate) {
      handleSummaryLayoutUpdate()
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleSummaryLayoutUpdateHandler)
    window.addEventListener('resize', handleSummaryLayoutUpdateHandler)
    handleSummaryLayoutUpdateHandler()

    return () => {
      window.removeEventListener('scroll', handleSummaryLayoutUpdateHandler)
      window.removeEventListener('resize', handleSummaryLayoutUpdateHandler)
    }
  }, [])

  return (
    <>
      <Container
        px="8"
        py={compact ? '4' : '8'}
        bg={
          compact
            ? Container.backgrounds.white
            : Container.backgrounds.hardWhite
        }
        divider={compact ? Container.dividers.top : null}>
        {!compact && (
          <>
            <Container fullWidth pb="8" divider={Container.dividers.bottom}>
              <TextCaption
                size={TextCaption.sizes.m}
                additionalClasses="q-text-turquoise">
                {translations.tk_cartSummary}
              </TextCaption>
            </Container>
            <Container
              fullWidth
              pt="8"
              pb="2"
              divider={Container.dividers.bottom}>
              <Container pb="6">
                <ListContainer columns={2} xBetween="2">
                  <Container fullWidth>
                    <TextBody
                      size={TextBody.sizes.m}
                      style={TextBody.styles.grayedout}
                      {...htmlTranslation(translations, 'tk_summarySubtotal')}
                    />
                  </Container>
                  <Container fullWidth>
                    <TextBody
                      size={TextBody.sizes.m}
                      alignment={TextBody.alignments.right}
                      data-testing="Cart_TextBody_Subtotal">
                      {subtotal}
                    </TextBody>
                  </Container>
                </ListContainer>
              </Container>
              <Container pb="6">
                <ListContainer columns={2} xBetween="2">
                  <Container fullWidth>
                    <TextBody
                      size={TextBody.sizes.m}
                      style={TextBody.styles.grayedout}
                      {...htmlTranslation(translations, 'tk_summaryDelivery')}
                    />
                  </Container>
                  <Container fullWidth>
                    <TextBody
                      size={TextBody.sizes.m}
                      additionalClasses="q-text-turquoise"
                      alignment={TextBody.alignments.right}
                      data-testing="Cart_TextBody_Delivery"
                      {...(deliveryFlat === 0
                        ? htmlTranslation(translations, 'tk_freeShipping')
                        : { value: delivery })}
                    />
                  </Container>
                </ListContainer>
              </Container>
            </Container>
          </>
        )}
        <Container pt={!compact ? '8' : '0'} fullWidth>
          <ListContainer columns={2} xBetween="2">
            <Container fullWidth>
              <TextTitle heading={TextTitle.headings.h5}>
                {translations.tk_summaryTotal}
              </TextTitle>
            </Container>
            <Container fullWidth>
              <TextTitle
                heading={TextTitle.headings.h5}
                alignment={TextBody.alignments.right}
                data-testing={
                  compact
                    ? 'Cart_TextTitle_TotalSticky'
                    : 'Cart_TextTitle_Total'
                }>
                {total}
              </TextTitle>
            </Container>
          </ListContainer>
        </Container>
        {isAuthenticated ? (
          <Container pt={!compact ? ['8', '8', '10'] : '4'}>
            <Button
              fullWidth
              variant={Button.variants.primary}
              text={translations.tk_summaryCheckout}
              onClickHandler={handleCartValidation}
              disabled={isCheckoutDisabled}
              loading={goToCheckoutCTALoading}
              data-testing={
                compact ? 'Cart_GoToCheckoutSticky' : 'Cart_GoToCheckout'
              }
            />
          </Container>
        ) : (
          <>
            <Container
              px="8"
              py="4"
              display={Container.displays.flex}
              justifyContent={Container.justifyContentValues.center}>
              {translations.tk_cartSummaryPreLoginDisclaimer && (
                <TextBody
                  size={TextBody.sizes.m}
                  alignment={TextBody.alignments.center}
                  style={TextBody.styles.error}
                  data-testing="Cart_TextBody_Disclaimer">
                  {translations.tk_cartSummaryPreLoginDisclaimer}
                </TextBody>
              )}
            </Container>
            <CartCheckoutGuestActions
              translations={translations}
              compact={compact}
            />
          </>
        )}
      </Container>
      {familyNotice && !compact && (
        <Container pt="8" px={['8', '8', '0']}>
          <Container
            fullWidth
            px={['6', '6', '8']}
            py="6"
            bg={Container.backgrounds.hardWhite}>
            <ListContainer columns={1} yBetween="3">
              <Container>
                <TextCaption size={TextCaption.sizes.m}>
                  {translations.tk_cartFamilyNoticeTitle}
                </TextCaption>
              </Container>
              <TextBody
                size={TextBody.sizes.s}
                {...htmlTranslation(
                  translations,
                  'tk_cartFamilyNoticeDescription'
                )}
              />
            </ListContainer>
          </Container>
        </Container>
      )}
    </>
  )
}

export default CartSummary
